$(document).ready(function($) {
    $("#baidu-map").each(function() {
        var points          = [];
        var infoWindow      = [];
        var marker          = [];
        var point_index     = [];
        $('#baidu-map .detail-point').each(function(){
           points.push({lat: $(this).data('lat'), lng: $(this).data('lng'), title:  $(this).data('title'), address: $(this).data('address'), link: $(this).data('link')});
        });
        var map = new BMap.Map("baidu-map");
        map.setMapStyle({
          styleJson: [{
            "featureType": "water",
            "elementType": "all",
            "stylers": {}
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": {
              "color": "#dcd4c2"
            }
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": {
              "color": "#08292f0f"
            }
          },
          {
            "featureType": "boundary",
            "elementType": "all",
            "stylers": {
              "color": "#08292fbf"
            }
          }]
        });
        if ($(document).width() <= 1023) {
            var point = new BMap.Point(points[0]['lng'], points[0]['lat']);
        }
        else {
            //center around the kazakstan for the middle of map
            var point = new BMap.Point(68.58274, 32.882004);
        }
        map.centerAndZoom(point, 3);
        map.addControl(new BMap.NavigationControl());
        for (var index in points) {
            var sContent =
            "<h2>" + points[index].title + "</h2>" +
            "<p>" + points[index].address + "</p>" +
            "<p><a href='" + points[index].link + "'>更多信息</a></p>" +
            "</div>";
            point_index[index] = new BMap.Point(points[index].lng, points[index].lat);
            var myIcon = new BMap.Icon(RAILS_ASSET_URL('favicon.png'), new BMap.Size(48, 48), {anchor: new BMap.Size(17, 32)});
            marker[index] = new BMap.Marker(point_index[index], {icon: myIcon});
            infoWindow[index] = new BMap.InfoWindow(sContent);
            map.addOverlay(marker[index]);
            marker[index].addEventListener("click", function(){
                var allOverlay = map.getOverlays();
                for (var i = 0; i < allOverlay.length -1; i++){
                    if(allOverlay[i] ==$(this)[0]){
                        this.openInfoWindow(infoWindow[i]);
                    }
                }
            });


        }
    });
});
